(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thirdreality-home-lower"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const startReviews = () => {
      document.querySelectorAll('[data-tr-review-track]').forEach((track) => {
        if (track.dataset.trReady === 'true') return;
        track.dataset.trReady = 'true';
        let paused = false;
        const pause = () => { paused = true; };
        const resume = () => { paused = false; };
        track.addEventListener('mouseenter', pause);
        track.addEventListener('mouseleave', resume);
        track.addEventListener('focusin', pause);
        track.addEventListener('focusout', resume);
        window.setInterval(() => {
          const overflow = track.scrollWidth - track.clientWidth;
          if (overflow <= 4 || paused) return;
          if (track.scrollLeft >= overflow - 2) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }
          track.scrollBy({ left: 1, behavior: 'auto' });
        }, 36);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startReviews);
    } else {
      startReviews();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thirdreality-launch-content-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-tr-launch-slider]').forEach((root) => {
      const slides = Array.from(root.querySelectorAll('[data-tr-launch-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-tr-launch-dot]'));
      const previousControls = Array.from(root.querySelectorAll('[data-tr-launch-previous]'));
      const nextControls = Array.from(root.querySelectorAll('[data-tr-launch-next]'));
      const interval = Number(root.dataset.trLaunchInterval || 6000);
      let current = 0;
      let timer;

      if (!slides.length) return;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === current));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === current));
      };

      const start = () => {
        clearInterval(timer);
        if (slides.length <= 1 || interval <= 0) return;
        timer = setInterval(() => show(current + 1), interval);
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          show(index);
          start();
        });
      });

      previousControls.forEach((control) => {
        control.addEventListener('click', () => {
          show(current - 1);
          start();
        });
      });

      nextControls.forEach((control) => {
        control.addEventListener('click', () => {
          show(current + 1);
          start();
        });
      });

      show(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thirdreality-launch-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-tr-launch-slider]');
    if (!root) return;

    const slides = Array.from(root.querySelectorAll('[data-tr-launch-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-tr-launch-dot]'));
    let current = 0;
    let timer;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    };

    const start = () => {
      clearInterval(timer);
      timer = setInterval(() => show(current + 1), 6000);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        show(index);
        start();
      });
    });

    show(0);
    start();
  })();

  } catch(e) { console.error(e); }
})();
})();
